import React from 'react';
import { ANSWER_LANGUAGES } from '../utils/answerTranslation';

const labelStyle = { display: 'block', fontSize: '13px', fontWeight: 600, color: '#094268', marginBottom: '4px', textAlign: 'left' };
const selectStyle = { width: '100%', boxSizing: 'border-box', height: '36px', padding: '4px 8px', fontSize: '14px', borderRadius: '6px', border: '1px solid #ccc' };

// Answer language picker, shown directly above the answer text area.
export const AnswerLanguageSelect = ({ t, disabled }) => (
  <div style={{ marginBottom: '10px' }}>
    <label style={labelStyle}>Answer Language</label>
    <select value={t.answerLanguage} onChange={(e) => t.setAnswerLanguage(e.target.value)} disabled={disabled} style={selectStyle}>
      {ANSWER_LANGUAGES.map((l) => <option key={l} value={l}>{l}</option>)}
    </select>
  </div>
);

// Translate To picker (always shown, below the answer text area) plus, only when
// it differs from the answer language, the translation text area and Translate button.
export const TranslatedAnswerBox = ({ t, answerText, disabled }) => (
  <div style={{ marginTop: '10px' }}>
    <label style={labelStyle}>Translate To</label>
    <select value={t.translationLanguage} onChange={(e) => t.setTranslationLanguage(e.target.value)} disabled={disabled} style={selectStyle}>
      {ANSWER_LANGUAGES.map((l) => <option key={l} value={l}>{l}</option>)}
    </select>

    {t.needsTranslation && (
      <div style={{ marginTop: '10px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
          <label style={{ ...labelStyle, marginBottom: 0 }}>Translated Answer ({t.translationLanguage})</label>
          <button
            type="button"
            onClick={() => t.translate(answerText).catch(() => {})}
            disabled={disabled || t.isTranslating || !answerText.trim()}
            style={{ padding: '4px 12px', borderRadius: '6px', border: '1px solid #094268', background: 'white', color: '#094268', fontWeight: 600, cursor: 'pointer' }}
          >
            {t.isTranslating ? 'Translating...' : 'Translate'}
          </button>
        </div>
        <textarea
          value={t.translation}
          onChange={(e) => t.setTranslation(e.target.value)}
          rows={5}
          disabled={disabled || t.isTranslating}
          placeholder="The translated answer will appear here."
          style={{ width: '100%', boxSizing: 'border-box', borderRadius: '6px', border: '1px solid #ccc', padding: '10px', fontSize: '15px', fontFamily: 'inherit', resize: 'vertical' }}
        />
        {t.translateError && <p style={{ color: '#c9302c', margin: '4px 0 0' }}>{t.translateError}</p>}
      </div>
    )}
  </div>
);
